import {
    RxJsonSchema,
    toTypedRxJsonSchema,
    ExtractDocumentTypeFromTypedRxJsonSchema
} from 'rxdb';
export const EXPENSE_SCHEMA_LITERAL = {
    title: 'Expense Schema',
    description: 'Expenses related to the University',
    version: 0,
    keyCompression: false,
    primaryKey: {
        key: 'id',
        fields:[
            'expense',
            'eligibility',
            'subcategory',
            'courseLoad'
        ],
        separator: '|'
    },
    type: 'object',
    properties: {
        id:{
            type: 'string',
            maxLength: 300
        },
        type:{
            type: 'string',
            default: '',
            maxLength: 100
        },
        expense:{
            type: 'string',
            default: '',
            maxLength: 200
        },
        subcategory:{
            type: 'string',
            default: '',
            maxLength: 200
        },
        cost:{
            type: 'number',
            minimum: 0
        },
        eligibility:{
            type: 'string',
            default: 'None',
            maxLength: 200
        },
        information:{
            type: 'string',
            default: '',
            maxLength: 500 
        },
        order:{
            type: 'number',
            default: 0,
            minimum: 0
        },
        courseLoad:{
            type: 'string',
            default: '',
            maxLength: 5
        }
    },
    required:[
        'type',
        'expense',
        'cost',
        'eligibility'
    ],
    indexes: [
        'eligibility',
        ['eligibility','courseLoad'],
        ['type','eligibility','courseLoad'],
        ['type','eligibility','expense'],
        'type'
    ]
} as const;

const schemaTyped = toTypedRxJsonSchema(EXPENSE_SCHEMA_LITERAL);
export type RxExpenseDocumentType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;

export const EXPENSE_SCHEMA: RxJsonSchema<RxExpenseDocumentType> = EXPENSE_SCHEMA_LITERAL;